// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FaLock, FaSpinner, FaEnvelope, FaKey, FaMobileAlt } from 'react-icons/fa';
// import { sendPhoneResetOtp, verifyPhoneResetOtp } from '../api/apiService';
// import api from '../api/apiService';

// // +++ ADD FIREBASE IMPORTS +++
// import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
// import { auth } from '../utils/firebase'; // adjust path if necessary

// function ForgotPassword() {
//   const [resetMethod, setResetMethod] = useState('phone'); // FIX: Default to 'phone'
//   const [phone, setPhone] = useState('');
//   // const [email, setEmail] = useState(''); // EMAIL FLOW COMMENTED OUT
//   const [otp, setOtp] = useState('');
//   const [step, setStep] = useState('sendOtp');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [successMsg, setSuccessMsg] = useState('');
//   const navigate = useNavigate();

//   // Firebase confirmation object (for phone flow)
//   const [firebaseConfirmation, setFirebaseConfirmation] = useState(null);
//   useEffect(() => {
//     let mounted = true;
//     const initRecaptcha = async () => {
//       try {
//         // Ensure the recaptcha container exists in the DOM. Some environments delay DOM insertion,
//         // so create and append it to the form if missing.
//         let container = document.getElementById('recaptcha-container');
//         if (!container) {
//           const formEl = document.querySelector('form');
//           if (formEl) {
//             container = document.createElement('div');
//             container.id = 'recaptcha-container';
//             // keep it visually hidden but available for Firebase
//             container.style.display = 'none';
//             formEl.appendChild(container);
//           }
//         }

//         if (!window.recaptchaVerifier && container) {
//           // FIX: auth must be the first argument to RecaptchaVerifier
//           window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
//             size: 'invisible',
//             callback: (response) => {
//               // reCAPTCHA solved — will be used by Firebase
//               console.log('reCAPTCHA verified');
//             }
//           });
//           await window.recaptchaVerifier.render();
//         }
//       } catch (e) {
//         console.error('Recaptcha setup error in ForgotPassword:', e);
//         if (mounted) setError('Could not initialize verification. Please refresh the page.');
//       }
//     };
//     initRecaptcha();
//     return () => { mounted = false; };
//   }, []);

//   const [resendCooldown, setResendCooldown] = useState(0);
//   const [resendCount, setResendCount] = useState(0);
//   const [resendError, setResendError] = useState('');
//   const [resendLoading, setResendLoading] = useState(false);
//   const RESEND_COOLDOWN_TIME = 60;
//   const MAX_RESEND_ATTEMPTS = 3;
//   const OTP_LENGTH = 6;

//   useEffect(() => {
//     let timer;
//     if (resendCooldown > 0) {
//       timer = setInterval(() => setResendCooldown((prev) => prev - 1), 1000);
//     }
//     return () => clearInterval(timer);
//   }, [resendCooldown]);

//   /*
//   // EMAIL input handler commented out
//   const handleEmailChange = (e) => {
//     setEmail(e.target.value);
//     setError('');
//     setSuccessMsg('');
//   };
//   */
//   const handlePhoneChange = (e) => setPhone(e.target.value.replace(/\D/g, ''));
//   const handleOtpChange = (e) => {
//     const value = e.target.value.replace(/\D/g, '');
//     if (value.length <= OTP_LENGTH) setOtp(value);
//     setError('');
//     setSuccessMsg('');
//     setResendError('');
//   };

//   const validateEmail = (inputEmail) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputEmail);

//   const handleSendOtp = async (e) => {
//     e.preventDefault();
//     setError('');
//     setSuccessMsg('');

//     // phone-only validation
//     if (!phone.trim()) {
//       setError('Please enter a valid phone number.');
//       return;
//     }

//     setLoading(true);
//     try {
//       // 1) Confirm the phone exists in our backend first
//       await api.post('/auth/check-phone', { phone });

//       // 2) Proceed to Firebase only if check succeeded
//       const appVerifier = window.recaptchaVerifier;
//       if (!appVerifier) throw new Error('Security verification failed to initialize. Please refresh the page.');

//       const phoneNumber = phone.startsWith('+') ? phone : `+91${phone}`; // adjust prefix if needed
//       const confirmation = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
//       setFirebaseConfirmation(confirmation);
//       setSuccessMsg(`An OTP has been sent to ${phoneNumber}.`);
//       setStep('verifyOtp');
//       setResendCooldown(RESEND_COOLDOWN_TIME);
//       setResendCount(0);
//     } catch (err) {
//       console.error('Send OTP error', err);
//       setError(err.response?.data?.error || err.message || 'An error occurred while sending OTP. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleVerifyOtp = async (e) => {
//     e.preventDefault();
//     setError('');
//     if (otp.length !== OTP_LENGTH) {
//       setError(`Please enter the ${OTP_LENGTH}-digit OTP.`);
//       return;
//     }
//     setLoading(true);
//     try {
//       let response;
//       /*
//       if (resetMethod === 'email') {
//         response = await api.post('/auth/verify-otp', { email, otp, purpose: 'reset-password' });
//       } else {
//       */
//         if (!firebaseConfirmation) throw new Error('No Firebase confirmation available. Re-send OTP.');
//         const result = await firebaseConfirmation.confirm(otp);
//         const firebaseToken = await result.user.getIdToken();
//         // Call backend to exchange firebase token for an app reset token
//         response = await api.post('/auth/issue-reset-token-firebase', { firebaseToken });
//       /*
//       }
//       */
//       const { token } = response.data;
//       navigate(`/reset-password?token=${token}`);
//     } catch (err) {
//       console.error('Verify OTP error', err);
//       setError(err.response?.data?.error || err.message || 'Invalid or expired OTP. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleResendOtp = async () => {
//     if (resendCooldown > 0 || resendCount >= MAX_RESEND_ATTEMPTS) return;
//     setResendLoading(true);
//     setResendCount((prev) => prev + 1);
//     setResendError('');
//     setSuccessMsg('');
//     try {
//       /*
//       if (resetMethod === 'email') {
//         await api.post('/auth/resend-otp', { email });
//         setSuccessMsg('A new OTP has been resent to your email.');
//       } else {
//       */
//         // +++ FIX: Use Firebase for phone resend (same flow as handleSendOtp) +++
//         const appVerifier = window.recaptchaVerifier;
//         if (!appVerifier) throw new Error('reCAPTCHA not initialized. Please refresh the page.');
//         const phoneNumber = phone.startsWith('+') ? phone : `+91${phone}`; // adjust prefix as needed
//         const confirmation = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
//         setFirebaseConfirmation(confirmation);
//         setSuccessMsg('A new OTP has been resent to your mobile.');
//       /*
//       }
//       */
//       setResendCooldown(RESEND_COOLDOWN_TIME);
//     } catch (err) {
//       setResendError(err.response?.data?.error || err.message || 'Failed to resend OTP.');
//     } finally {
//       setResendLoading(false);
//     }
//   };

//   return (
//     <div className="d-flex justify-content-center align-items-center bg-light" style={{ minHeight: '100vh' }}>
//       <div className="card shadow-lg" style={cardStyle}>
//         <div className="card-body p-4">
//           <div className="text-center mb-4">
//             <div style={iconContainerStyle}><FaLock size={24} color="#007bff" /></div>
//             <h3 className="card-title mt-3">Forgot Password</h3>
//             {/* Original line using resetMethod/email commented out to avoid referencing commented email state */}
//             {/* <p className="text-muted">{step === 'sendOtp' ? 'Choose how to receive your OTP.' : `Enter the OTP sent to ${resetMethod === 'email' ? email : phone}.`}</p> */}
//             {/* <p className="text-muted">{step === 'sendOtp' ? 'Choose how to receive your OTP.' : `Enter the OTP sent to your phone.`}</p> */}
//           </div>

//           {successMsg && <div className="alert alert-success text-center mb-3">{successMsg}</div>}
//           {error && <div className="alert alert-danger text-center mb-3">{error}</div>}

//           <form onSubmit={step === 'sendOtp' ? handleSendOtp : handleVerifyOtp}>
//             {step === 'sendOtp' && (
//               <>
//                 <div className="btn-group w-100 mb-3" role="group">
//                   {/* FIX: The Phone button is now first, so it will render on the left */}
//                   <button type="button" className={`btn ${resetMethod === 'phone' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setResetMethod('phone')}>
//                     <FaMobileAlt className="me-2" /> Phone
//                   </button>
//                   {/* Email selection commented out - phone-only flow */}
//                   {/* <button type="button" className={`btn ${resetMethod === 'email' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setResetMethod('email')}>
//                     <FaEnvelope className="me-2" /> Email
//                   </button> */}
//                 </div>

//                 {/*
//                 // Original conditional (email/phone) commented out - phone input shown by default
//                 {resetMethod === 'email' ? (
//                   <div className="mb-3">
//                     <label className="form-label">Email Address</label>
//                     <input type="email" className="form-control" value={email} onChange={handleEmailChange} />
//                   </div>
//                 ) : (
//                   <div className="mb-3">
//                     <label className="form-label">Phone Number</label>
//                     <input type="tel" className="form-control" value={phone} onChange={handlePhoneChange} />
//                   </div>
//                 )}
//                 */}
//                 <div className="mb-3">
//                   <label className="form-label">Phone Number</label>
//                   <input type="tel" className="form-control" value={phone} onChange={handlePhoneChange} />
//                 </div>
//               </>
//             )}

//             {step === 'verifyOtp' && (
//               <div className="mb-3">
//                 <label className="form-label">OTP</label>
//                 <input type="text" className="form-control text-center" value={otp} onChange={handleOtpChange} maxLength={6} />
//                 <div className="d-flex justify-content-between align-items-center mt-3">
//                   {resendCooldown > 0 ? <p className="text-muted small mb-0">Resend OTP in {resendCooldown}s</p> :
//                     <button type="button" className="btn btn-link p-0" onClick={handleResendOtp} disabled={resendLoading || resendCount >= MAX_RESEND_ATTEMPTS}>
//                       {resendLoading ? <FaSpinner className="fa-spin" /> : 'Resend OTP'}
//                     </button>
//                   }
//                 </div>
//               </div>
//             )}

//             <button type="submit" className="btn btn-primary w-100 mt-3" disabled={loading}>
//               {loading ? <FaSpinner className="fa-spin" /> : (step === 'sendOtp' ? 'Send OTP' : 'Verify OTP')}
//             </button>
//             {/* Firebase reCAPTCHA container for phone auth - required and must be inside the form */}
//             <div id="recaptcha-container" style={{ display: 'none' }}></div>
//           </form>

//           <div className="text-center mt-4 text-muted">
//             <a href="/login" className="text-decoration-none" style={linkButtonStyle}>Back to Login</a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // Styles (same as your current file)
// const cardStyle = { width: '24rem', borderRadius: '1rem', background: '#ffffff', border: '1px solid #e0e0e0', boxShadow: '0 8px 20px rgba(0,0,0,0.08)' };
// const iconContainerStyle = { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#e9f5ff', borderRadius: '50%', padding: '0.8rem', border: '1px solid #cce5ff', width: '50px', height: '50px', marginBottom: '1rem' };
// const linkButtonStyle = { color: '#007bff', textDecoration: 'none' };

// export default ForgotPassword;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLock, FaSpinner, FaEnvelope, FaKey, FaMobileAlt } from 'react-icons/fa';
import { sendPhoneResetOtp, verifyPhoneResetOtp } from '../api/apiService';
import api from '../api/apiService';
import '../styles/ForgotPassword.css';
// +++ ADD FIREBASE IMPORTS +++
import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { auth } from '../utils/firebase'; // adjust path if necessary

function ForgotPassword() {
  const [resetMethod, setResetMethod] = useState('phone'); // FIX: Default to 'phone'
  const [phone, setPhone] = useState('');
  // const [email, setEmail] = useState(''); // EMAIL FLOW COMMENTED OUT
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState('sendOtp');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const navigate = useNavigate();

  // Firebase confirmation object (for phone flow)
  const [firebaseConfirmation, setFirebaseConfirmation] = useState(null);
  useEffect(() => {
    let mounted = true;
    const initRecaptcha = async () => {
      try {
        // Ensure the recaptcha container exists in the DOM. Some environments delay DOM insertion,
        // so create and append it to the form if missing.
        let container = document.getElementById('recaptcha-container');
        if (!container) {
          const formEl = document.querySelector('form');
          if (formEl) {
            container = document.createElement('div');
            container.id = 'recaptcha-container';
            // keep it visually hidden but available for Firebase
            container.style.display = 'none';
            formEl.appendChild(container);
          }
        }

        if (!window.recaptchaVerifier && container) {
          // FIX: auth must be the first argument to RecaptchaVerifier
          window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
            size: 'invisible',
            callback: (response) => {
              // reCAPTCHA solved — will be used by Firebase
              console.log('reCAPTCHA verified');
            }
          });
          await window.recaptchaVerifier.render();
        }
      } catch (e) {
        console.error('Recaptcha setup error in ForgotPassword:', e);
        if (mounted) setError('Could not initialize verification. Please refresh the page.');
      }
    };
    initRecaptcha();
    return () => { mounted = false; };
  }, []);

  const [resendCooldown, setResendCooldown] = useState(0);
  const [resendCount, setResendCount] = useState(0);
  const [resendError, setResendError] = useState('');
  const [resendLoading, setResendLoading] = useState(false);
  const [countryCode, setCountryCode] = useState("+91");
  const RESEND_COOLDOWN_TIME = 60;
  const MAX_RESEND_ATTEMPTS = 3;
  const OTP_LENGTH = 6;

  useEffect(() => {
    let timer;
    if (resendCooldown > 0) {
      timer = setInterval(() => setResendCooldown((prev) => prev - 1), 1000);
    }
    return () => clearInterval(timer);
  }, [resendCooldown]);

  /*
  // EMAIL input handler commented out
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setError('');
    setSuccessMsg('');
  };
  */
  const handlePhoneChange = (e) => setPhone(e.target.value.replace(/\D/g, ''));
  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= OTP_LENGTH) setOtp(value);
    setError('');
    setSuccessMsg('');
    setResendError('');
  };

  const validateEmail = (inputEmail) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputEmail);

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMsg('');

    // phone-only validation
    if (!phone.trim()) {
      setError('Please enter a valid phone number.');
      return;
    }

    setLoading(true);
    try {
      // 1) Confirm the phone exists in our backend first
      // await api.post('/auth/check-phone', { phone });
      const fullPhone = phone.startsWith('+') ? phone : `+91${phone}`;

      await api.post('/auth/check-phone', { phone: fullPhone });

      // 2) Proceed to Firebase only if check succeeded
      const appVerifier = window.recaptchaVerifier;
      if (!appVerifier) throw new Error('Security verification failed to initialize. Please refresh the page.');

      const phoneNumber = phone.startsWith('+') ? phone : `+91${phone}`; // adjust prefix if needed
      const confirmation = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
      setFirebaseConfirmation(confirmation);
      setSuccessMsg(`An OTP has been sent to ${phoneNumber}.`);
      setStep('verifyOtp');
      setResendCooldown(RESEND_COOLDOWN_TIME);
      setResendCount(0);
    } catch (err) {
      console.error('Send OTP error', err);
      setError(err.response?.data?.error || err.message || 'An error occurred while sending OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setError('');
    if (otp.length !== OTP_LENGTH) {
      setError(`Please enter the ${OTP_LENGTH}-digit OTP.`);
      return;
    }
    setLoading(true);
    try {
      let response;
      /*
      if (resetMethod === 'email') {
        response = await api.post('/auth/verify-otp', { email, otp, purpose: 'reset-password' });
      } else {
      */
      if (!firebaseConfirmation) throw new Error('No Firebase confirmation available. Re-send OTP.');
      const result = await firebaseConfirmation.confirm(otp);
      const firebaseToken = await result.user.getIdToken();
      // Call backend to exchange firebase token for an app reset token
      response = await api.post('/auth/issue-reset-token-firebase', { firebaseToken });
      /*
      }
      */
      const { token } = response.data;
      navigate(`/reset-password?token=${token}`);
    } catch (err) {
      console.error('Verify OTP error', err);
      setError(err.response?.data?.error || err.message || 'Invalid or expired OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (resendCooldown > 0 || resendCount >= MAX_RESEND_ATTEMPTS) return;
    setResendLoading(true);
    setResendCount((prev) => prev + 1);
    setResendError('');
    setSuccessMsg('');
    try {
      /*
      if (resetMethod === 'email') {
        await api.post('/auth/resend-otp', { email });
        setSuccessMsg('A new OTP has been resent to your email.');
      } else {
      */
      // +++ FIX: Use Firebase for phone resend (same flow as handleSendOtp) +++
      const appVerifier = window.recaptchaVerifier;
      if (!appVerifier) throw new Error('reCAPTCHA not initialized. Please refresh the page.');
      const phoneNumber = phone.startsWith('+') ? phone : `+91${phone}`; // adjust prefix as needed
      const confirmation = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
      setFirebaseConfirmation(confirmation);
      setSuccessMsg('A new OTP has been resent to your mobile.');
      /*
      }
      */
      setResendCooldown(RESEND_COOLDOWN_TIME);
    } catch (err) {
      setResendError(err.response?.data?.error || err.message || 'Failed to resend OTP.');
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center bg-light" style={{ minHeight: '100vh' }}>
      <div className="card shadow-lg" style={cardStyle}>
        <div className="card-body p-4">
          <div className="text-center mb-4">
            <div style={iconContainerStyle}><FaLock size={24} color="#007bff" /></div>
            <h3 className="card-title mt-3">Forgot Password</h3>
            {/* Original line using resetMethod/email commented out to avoid referencing commented email state */}
            {/* <p className="text-muted">{step === 'sendOtp' ? 'Choose how to receive your OTP.' : `Enter the OTP sent to ${resetMethod === 'email' ? email : phone}.`}</p> */}
            <p className="text-muted">{step === 'sendOtp' ? 'Choose how to receive your OTP.' : `Enter the OTP sent to your phone.`}</p>
          </div>

          {successMsg && <div className="alert alert-success text-center mb-3">{successMsg}</div>}
          {error && <div className="alert alert-danger text-center mb-3">{error}</div>}

          <form onSubmit={step === 'sendOtp' ? handleSendOtp : handleVerifyOtp}>
            {step === 'sendOtp' && (
              <>
                <div className="btn-group w-100 mb-3" role="group">
                  {/* FIX: The Phone button is now first, so it will render on the left */}
                  <button type="button" className={`btn ${resetMethod === 'phone' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setResetMethod('phone')}>
                    <FaMobileAlt className="me-2" /> Phone
                  </button>
                  {/* Email selection commented out - phone-only flow */}
                  {/* <button type="button" className={`btn ${resetMethod === 'email' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setResetMethod('email')}>
                    <FaEnvelope className="me-2" /> Email
                  </button> */}
                </div>

                {/*
                // Original conditional (email/phone) commented out - phone input shown by default
                {resetMethod === 'email' ? (
                  <div className="mb-3">
                    <label className="form-label">Email Address</label>
                    <input type="email" className="form-control" value={email} onChange={handleEmailChange} />
                  </div>
                ) : (
                  <div className="mb-3">
                    <label className="form-label">Phone Number</label>
                    <input type="tel" className="form-control" value={phone} onChange={handlePhoneChange} />
                  </div>
                )}
                */}
                <div className="mb-3">
                  <label className="form-label">Phone Number</label>
                  <div className="mobile-input-wrappers">
                    <select
                      value={countryCode}
                      onChange={(e) => setCountryCode(e.target.value)}
                    >
                      <option value="+91">IN +91</option>
                      {/* <option value="+1">🇺🇸 +1</option> */}
                    </select>

                    <input
                      type="tel"
                      placeholder="Enter Mobile Number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
                    />
                  </div>
                </div>
              </>
            )}

            {step === 'verifyOtp' && (
              <div className="mb-3">
                <label className="form-label">OTP</label>
                <input type="text" className="form-control text-center" value={otp} onChange={handleOtpChange} maxLength={6} />
                <div className="d-flex justify-content-between align-items-center mt-3">
                  {resendCooldown > 0 ? <p className="text-muted small mb-0">Resend OTP in {resendCooldown}s</p> :
                    <button type="button" className="btn btn-link p-0" onClick={handleResendOtp} disabled={resendLoading || resendCount >= MAX_RESEND_ATTEMPTS}>
                      {resendLoading ? <FaSpinner className="fa-spin" /> : 'Resend OTP'}
                    </button>
                  }
                </div>
              </div>
            )}

            <button type="submit" className="btn btn-primary w-100 mt-3" disabled={loading}>
              {loading ? <FaSpinner className="fa-spin" /> : (step === 'sendOtp' ? 'Send OTP' : 'Verify OTP')}
            </button>
            {/* Firebase reCAPTCHA container for phone auth - required and must be inside the form */}
            <div id="recaptcha-container" style={{ display: 'none' }}></div>
          </form>

          <div className="text-center mt-4 text-muted">
            <a href="/login" className="text-decoration-none" style={linkButtonStyle}>Back to Login</a>
          </div>
        </div>
      </div>
    </div>
  );
}

// Styles (same as your current file)
const cardStyle = { width: '24rem', borderRadius: '1rem', background: '#ffffff', border: '1px solid #e0e0e0', boxShadow: '0 8px 20px rgba(0,0,0,0.08)' };
const iconContainerStyle = { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#e9f5ff', borderRadius: '50%', padding: '0.8rem', border: '1px solid #cce5ff', width: '50px', height: '50px', marginBottom: '1rem' };
const linkButtonStyle = { color: '#007bff', textDecoration: 'none' };

export default ForgotPassword;